import Styles from './Drawer.module.scss'
import { PropsWithChildren } from 'react'
import { WithClassName, WithColor } from './Types'
import cx from 'classnames'

export const Top = ({
  children,
  className,
  color = 'var(--light-100)',
}: PropsWithChildren<WithColor & WithClassName>) => (
  <div className={cx(Styles.top, className)} style={{ backgroundColor: color }}>
    {children}
  </div>
)
